/* ============
 * Mutations for the cvc module
 * ============
 *
 * The mutations that are available on the
 * cvc module.
 */

export default {
  setJWT (state, payload) {
    state.jwt = payload
  },
  setExp (state, payload) {
    state.exp = payload
  },
  setPayments (state, payload) {
    state.paymentsParams = payload
  },
  setSubscribe (state, payload) {
    state.subscribe = payload
  },
  clear (state) {
    state.paymentsParams = null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/payments/mutations.js